import { isLanguage, type Language } from '@/shared/lib/i18n'

const portalLangRegexp = /^\/(?<lang>[a-z]{2})(\/|$)/u

export function getRouterLanguage(ctx: { query?: { lang?: string }; asPath?: string }): Language | null {
    const lang = ctx.query?.lang as string
    if (isLanguage(lang)) {
        return lang
    }

    if (ctx.asPath) {
        const match = ctx.asPath.match(portalLangRegexp)
        const lang = match?.groups?.lang?.toLowerCase()
        if (isLanguage(lang)) {
            return lang
        }
    }

    return null
}
